module.exports = __webpack_public_path__ + "7a06846baf7fd2cfb18c7ab4d663c8ca.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Rubik/Rubik-Light.ttf
// module id = 1262
// module chunks = 0